<template>
  <div class="portal-page-fill status-details">
    <div class="status-manager" v-if="refinedStatus">
      <div class="top-header toolbar-card">
        <div class="search">
          <div class="icon">
            <span class="mdi mdi-magnify"></span>
          </div>
          <input
            class="search-bar"
            :placeholder="$t('search.statusplaceholder')"
            v-model="search"
          />
        </div>
        <div class="filters-container" >
          <GateTabs :value="filter" @update="updatefilter"/>
        </div>
        <div class="create-status" >
          <span v-if="
                this.permissions.includes('Create-Status')"
            @click="createNewStatus"
            class="mdi mdi-plus-circle-outline add"
          ></span>
        </div>
      </div>
    </div>
    <div class="status-reports portal-reports">
      <h6 class="report-title">
        {{ $t("flightstatus.datepicker-title") }}
        <date-picker v-model="selectedDate" range :format="dateFormat" :placeholder="[[currentDate]] + ' ~ ' + [[currentDate]]"></date-picker>
        <input class="radio-btn" type="radio" id="PDF" value="pdf"  v-model="fileFormat"/>
        <label for="PDF">{{ $t("flightstatus.pdf-btn") }}</label>
        <input class="radio-btn" type="radio" id="CSV"  value="csv" v-model="fileFormat"/>
        <label for="CSV">{{ $t("flightstatus.csv-btn") }}</label>
        <input class="radio-btn" type="radio" id="EXCEL" value="xlsx" v-model="fileFormat"/>
        <label for="EXCEL">{{ $t("flightstatus.excel-btn") }}</label>
        <button class="btn btn-primary float-right report-btn" @click="downloadReports">
          {{ $t("flightstatus.download-btn") }}
        </button>
      </h6>
    </div>
    <div class="status-table portal-table-wrap table-card">
      <div class="portal-table-scroll">
        <table class="table">
        <thead>
          <tr class="table-header">
            <th
              class="user-table-headers"
              :class="[{ sorting: sort == 'name' }, direction]"
              @click="updateSort('name')"
            >
              {{ $t("flightstatus.statusTable.claimname") }}
            </th>
            <th
              class="user-table-headers"
              :class="[{ sorting: sort == 'status' }, direction]"
              @click="updateSort('status')"
            >
              {{ $t("flightstatus.statusTable.status") }}
            </th>
            <th
              class="user-table-headers"
              v-if="
                this.permissions.includes('Edit-Status') ||
                this.permissions.includes('Delete-Status')
              "
            >
              {{ $t("flightstatus.statusTable.action") }}
            </th>
          </tr>
        </thead>
        <PortalTableBody
          :loading="loading"
          variant="name-status"
          :show-actions="hasActionColumn"
        >
        <template
          v-if="
            !this.permissions.includes('Edit-Status') &&
            !this.permissions.includes('Delete-Status')
          "
        >
          <tr v-for="(item, idx) in refinedStatus" :key="idx">
            <td>{{ item.display_name }}</td>
            <td v-if="item.is_active == 0">Disabled</td>
            <td v-else>Enabled</td>
          </tr>
        </template>

        <template
          v-else-if="
            this.permissions.includes('Edit-Status') &&
            this.permissions.includes('Delete-Status')
          "
        >
          <tr v-for="(item, idx) in refinedStatus" :key="idx">
            <td>{{ item.display_name }}</td>
            <td v-if="item.is_active == 0">Disabled</td>
            <td v-else>Enabled</td>
            <td>
              <div class="row d-flex justify-content-center">
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editStatusDetails(idx)"
                  ></span>
                </div>
                <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(idx)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
        </template>

        <template
          v-else-if="
            this.permissions.includes('Delete-Status') &&
            !this.permissions.includes('Edit-Status')
          "
        >
          <tr v-for="(item, idx) in refinedStatus" :key="idx">
            <td>{{ item.display_name }}</td>
            <td v-if="item.is_active == 0">Disabled</td>
            <td v-else>Enabled</td>
            <td>
              <div class="row d-flex justify-content-center">
                <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(idx)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
        </template>

        <template
          v-else-if="
            this.permissions.includes('Edit-Status') &&
            !this.permissions.includes('Delete-Status')
          "
        >
          <tr v-for="(item, idx) in refinedStatus" :key="idx">
            <td>{{ item.display_name }}</td>
            <td v-if="item.is_active == 0">Disabled</td>
            <td v-else>Enabled</td>
            <td>
              <div class="row d-flex justify-content-center">
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editStatusDetails(idx)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
        </template>
        </PortalTableBody>
      </table>
      </div>
    </div>
    <div class="footer portal-footer">
      <div class="results">
        <span class="mdi mdi-format-list-bulleted results-icon" aria-hidden="true"></span>
        {{ $t("displayresults.display") }} <strong>{{ resultsCopy }}</strong> {{ $t("displayresults.results")}}
      </div>
    </div>
    <!-- Pop Up Modal -->
    <div v-if="myModel">
      <transition name="model">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click="myModel = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="confirmation pb-4" style="text-align: center">
                    <h4>{{ $t("deletepop.message")}}</h4>
                  </div>
                  <div align="center">
                    <input
                      type="button"
                      class="btn btn-primary"
                      style="margin-right: 10px; width: 100px"
                      :value="$t('deletepop.okbtn')" 
                      @click="deleteStatus(modalData)"
                    />
                    <input
                      type="button"
                      class="btn btn-danger"
                      style="margin-left: 10px; width: 100px"
                      :value="$t('deletepop.cancelbtn')"
                      @click="myModel = false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import GateTabs from '../GateTabs.vue';
import PortalTableBody from '../PortalTableBody.vue';
import { routeNames } from '../../js/routeNames';
import axios from 'axios';
import { decryptData } from '../../js/utils/encrypt';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

export default {
  data: function () {
    return {
      loading: false,
      myModel: false,
      statusData: '',
      permissions: [],
      modalData: '',
      search: '',
      filter: 'all',
      model: false,
      selectedDate: '',
      fileFormat: 'pdf',
      test1: false,
      test2: false,
      test3: false,
      date: '',
      currentDate: '',
      dateFormat: 'YYYY-MM-DD',
      userName: ''
    };
  },
  props: {
    direction: String,
    sort: String,
  },
  components: {
    GateTabs,
    DatePicker,
    PortalTableBody,
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },
  
    refinedStatus() {
      if (!Array.isArray(this.statusData)) {
        return [];
      }
      let refined = this.filterStatus(this.statusData);
      refined = this.searchStatus(refined);
      if (this.sort) {
        refined = this.sortStatus(refined);
      }
      return this.direction === 'ascending' ? refined : refined.slice().reverse();
    },
    resultsCopy() {
      const length = this.refinedStatus.length;
      return `${length}`; 
    },
    hasActionColumn() {
      return (
        this.permissions.includes('Edit-Status') ||
        this.permissions.includes('Delete-Status')
      );
    }
  },
  mounted() {
    let today = new Date();
    this.currentDate = moment(today).format(this.dateFormat);
    this.userName= localStorage.getItem('username').replace(/['"]+/g,'');

    //Decrypting Permissions
    let mkLocalData = localStorage.getItem('Permissions');
    if (!mkLocalData) {
      mkLocalData = 'null';
    }
    const secretPermissionKey = process.env.KEY || 'myscecretkey';
    this.permissions = decryptData(mkLocalData, secretPermissionKey);
    (this.loading = true),
      axios
        .get(this.$hostName + '/flightstatus')
        .then((response) => {
          this.statusData = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
  },
  methods: {
    refreshPortalPage() {
      this.loading = true;
      axios
        .get(this.$hostName + '/flightstatus')
        .then((response) => {
          this.statusData = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filterStatus(data) {
      const rows = Array.isArray(data) ? data : [];
      if(this.filter != 'all') {
        return rows.filter( (gate) => {
          return gate.is_active.toString().toLowerCase() == this.filter;
        });
      }
      return rows;
    },
    sortStatus(data) {
      const rows = Array.isArray(data) ? data.slice() : [];
      switch (this.sort) {
        case 'name':
        case 'status':
          return rows.sort((gateA, gateB) => {
            if (gateA[this.sort] < gateB[this.sort]) {
              return -1;
            }
            if (gateA[this.sort] > gateB[this.sort]) {
              return 1;
            }
            return 0;
          });

        default:
          return rows;
      }
    },
    searchStatus(data) {
      const rows = Array.isArray(data) ? data : [];
      if (!this.search) return rows;
      return rows.filter((gate) => {
        return (
          gate.display_name &&
          gate.display_name
            .toString()
            .toLowerCase()
            .includes(this.search.toString().toLowerCase())
        );
      });
    },
    downloadReports(){
      const fromDate = moment(this.selectedDate[0]).format('YYYY-MM-DD');
      const toDate = moment(this.selectedDate[1]).format('YYYY-MM-DD');
      const fileType = this.fileFormat; 
      var formData = {
        fDate: fromDate,
        tDate: toDate,
        filter: this.filter,
        uName: this.userName,
        rName: 'Flight Status List',
        rType: 'status',
        fType: fileType
      };
      this.loading = true;
      axios({
      url: this.$hostName + '/downloadReport',
      method: 'POST',
      responseType: 'blob',
      data: formData,
      }).then((response) => {
          const binaryResponse = new Blob([response.data]);
          if(binaryResponse.size > 10) {
            var fileURL = window.URL.createObjectURL(binaryResponse);
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            var fileName = 'FlightStatus_'+ moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +'.'+fileType;
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
          }else {
            this.$alert('No data for the selected filter criteria');
          }
      }).finally(() => {
          this.loading =  false;
      });    
    },
    updatefilter(value) {
      this.filter = value;
    },
    updateSort(value) {
      this.$emit('updateSort', value);
    },
    createNewStatus() {
      this.$router.push({ name: routeNames.newStatus });
    },

    goToRoute(route) {
      if (this.navOpen) this.toggleNav();
      if (route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    },
    editStatusDetails(idx) {
      var editid = this.refinedStatus[idx].id;
      var display_name = this.refinedStatus[idx].display_name;
      var is_active = this.refinedStatus[idx].is_active;
      var direction = this.refinedStatus[idx].direction;
      this.$router.push({ 
        name: 'edit-status', 
        params: { 
          display_name ,
          is_active,
          editid,
          direction
        } 
      });
    },
    openModel(idx) {
      this.myModel = true;
      this.modalData = idx;
    },
    reportsModel() {
      this.model = true;
    },
    deleteStatus(idx) {
      this.loading = true;
        axios
            .delete(this.$hostName + '/status/' + this.refinedStatus[idx].id)
          .then((response) => {
            if (response.status == 200) {
              this.myModel = false;
              this.$emit('Flight Status Deleted');
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.getStatus();
          });
    },
    getStatus() {
      axios
        .get(this.$hostName + '/flightstatus')
        .then((response) => {
          this.statusData = response.data;
        })
        .finally(() => {
          this.loading = false;
          this.$alert('Flight Status removed succesfully');
        });
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
    width: 100%;
    height: 60px;
    min-height: 60px;
    background-color: $general-gray-light;
    padding: 0 25px;
    border-top: solid 1px $general-white;
    position: absolute;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .results {
      display: flex;
      align-items: center;
      font-size: 12px;
      padding-right: 20px;
      color: $general-black-light;
    }
  }
.radio-btn{
  margin-left: 5%;
}
.status-reports {
  background-color: #F0F7FF;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-left: 1%;
  margin-right: 1%;
}
.report-title {
  margin-left: 2%;
}
.report-btn {
  margin-right: 2%;
}
tr {
  text-align: center;
}
td {
  text-align: center;
  vertical-align: baseline !important;
}
.status-table {
  min-height: 0;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-content {
  width: 500px !important;
}
.icon {
  font-size: 25px;
}
.edit {
  color: #007bff;
  top: 5px;
  margin-right: 10px;
}
.edit:hover {
  cursor: pointer;
}
.delete {
  color: red;
  margin-left: 10px;
}
.delete:hover {
  cursor: pointer;
}
.add:hover {
  cursor: pointer;
}
.title {
  display: flex;
  justify-content: center;
}
.status-header {
  margin-top: 2%;
  margin-bottom: 2%;
  margin-left: 5%;
  margin-right: 5%;
}
.status-manager {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>